export default "__VITE_ASSET__Bii9BhfI__"